import { Picker } from '@react-native-picker/picker';
import moment from 'moment';
import React, { useEffect, useState, useMemo } from 'react';
import {
  ActivityIndicator,
  ScrollView,
  Text,
  TouchableOpacity,
  View,
} from 'react-native';
import { Card } from 'react-native-paper';
import FontAwesome from '@react-native-vector-icons/fontawesome';
import { useSelector } from 'react-redux';
import {
  getContrastColor,
  retrieveSetting,
  storeSetting,
} from '../Common/common';
import { Col, Row } from '../Components/BTGrid';
import { useGetFORoomssQuery } from '../redux/services/foroomsApi';
import { useGetFOEActiveLinkRoomsQuery } from '../redux/services/foelinkroomsApi';
import { RootState } from '../redux/store';
import styles from '../styles/FOStyles';
import {
  filterRoomsList,
  renderRoomBadges,
  getRoomStatusLabel,
  getRoomColor,
} from '../utils/statusScreenUtils';
import ExtendStayModal from '../Components/ExtendStayModal';
import RequestAuthorizationModal from '../Components/RequestAuthorizationModal';

import T from '../Components/T';
const StatusScreen = ({ navigation }: UniversalProps) => {
  const gdata = useSelector((state: RootState) => state.gdata);
  const cid = gdata.company;
  const { data: roomsData = [], isLoading, refetch: refetchRooms } = useGetFORoomssQuery(cid);
  const { data: activeLinkRooms = [] } = useGetFOEActiveLinkRoomsQuery(cid, { skip: !cid });

  const [rooms, setRooms] = useState<any[]>([]);
  const [listType, setListType] = useState(1);
  const [filter, setFilter] = useState(1);
  const [showColors, setShowColors] = useState(true);
  const [showBadges, setShowBadges] = useState(true);

  // Modals state
  const [extendModalRoom, setExtendModalRoom] = useState<any | null>(null);
  const [authModalRoom, setAuthModalRoom] = useState<any | null>(null);

  const linkedRoomIdsSet = useMemo(() => {
    const set = new Set<number>();
    if (activeLinkRooms && Array.isArray(activeLinkRooms)) {
      for (const link of activeLinkRooms) {
        if (link.lr_room) set.add(Number(link.lr_room));
        if (link.ld_room) set.add(Number(link.ld_room));
      }
    }
    return set;
  }, [activeLinkRooms]);

  useEffect(() => {
    storeSetting('statustype', listType.toString());
    storeSetting('statusfilter', filter.toString());

    if (roomsData) {
      const filtered = filterRoomsList(roomsData, filter, listType).map(r => ({
        ...r,
        is_linked: linkedRoomIdsSet.has(Number(r.rm_id)),
      }));
      setRooms(filtered);
    }
  }, [roomsData, listType, filter, linkedRoomIdsSet]);

  useEffect(() => {
    storeSetting('status_show_colors', showColors.toString());
  }, [showColors]);

  useEffect(() => {
    storeSetting('status_show_badges', showBadges.toString());
  }, [showBadges]);

  useEffect(() => {
    const fetchDefaults = async () => {
      const types = await retrieveSetting('statustype');
      const filters = await retrieveSetting('statusfilter');
      const savedColors = await retrieveSetting('status_show_colors');
      const savedBadges = await retrieveSetting('status_show_badges');

      const parsedTypes = Number(types);
      const parsedFilters = Number(filters);

      setListType(!types || isNaN(parsedTypes) || parsedTypes <= 0 ? 1 : parsedTypes);
      setFilter(!filters || isNaN(parsedFilters) || parsedFilters <= 0 ? 1 : parsedFilters);
      if (savedColors !== null && savedColors !== undefined && savedColors !== '') {
        setShowColors(savedColors === 'true');
      }
      if (savedBadges !== null && savedBadges !== undefined && savedBadges !== '') {
        setShowBadges(savedBadges === 'true');
      }
    };
    fetchDefaults();
  }, []);

  if (isLoading) {
    return (
      <View style={styles.loaderContainer}>
        <ActivityIndicator size="large" color="#ff9800" />
      </View>
    );
  }

  return (
    <View style={{ flex: 1, backgroundColor: '#f5f5f5' }}>
      <ScrollView
        contentContainerStyle={{
          padding: 8,
          paddingBottom: 80,
          flexGrow: 1,
          backgroundColor: '#f5f5f5',
        }}
        keyboardShouldPersistTaps="handled">
        <View style={styles.header}>
          <Text style={styles.title}><T>Room Status</T></Text>
          <Text style={styles.title}>
            {` ${
              rooms.filter(room => room.rm_status === 'O').length
            } Occupied of ${rooms.length}`}
          </Text>
        </View>
        <View>
          <Row>
            <Col>
              <Picker
                selectedValue={listType}
                onValueChange={newValue => {
                  setListType(newValue);
                }}
                dropdownIconColor="black"
                style={{
                  height: 52,
                  color: 'black',
                  backgroundColor: 'white',
                  borderRadius: 4,
                  borderWidth: 1,
                  borderColor: '#ccc',
                  fontSize: 14,
                  justifyContent: 'center',
                }}
              >
                <Picker.Item key={1} label="Room Name" value={1} />
                <Picker.Item key={2} label="Room Type" value={2} />
              </Picker>
            </Col>
            <Col>
              <Picker
                selectedValue={filter}
                onValueChange={newValue => {
                  setFilter(newValue);
                }}
                dropdownIconColor="black"
                style={{
                  height: 52,
                  color: 'black',
                  backgroundColor: 'white',
                  borderRadius: 4,
                  borderWidth: 1,
                  borderColor: '#ccc',
                  fontSize: 14,
                  justifyContent: 'center',
                }}
              >
                <Picker.Item key={1} label="All" value={1} />
                <Picker.Item key={2} label="Vacant" value={2} />
                <Picker.Item key={3} label="Occupied" value={3} />
                <Picker.Item key={4} label="Dirty" value={4} />
                <Picker.Item key={5} label="Block" value={5} />
                <Picker.Item key={6} label="Repair" value={6} />
                <Picker.Item key={7} label="Exp. Checkout" value={7} />
                <Picker.Item key={8} label="Hourly" value={8} />
                <Picker.Item key={9} label="Monthly" value={9} />
                <Picker.Item key={10} label="Refreshment" value={10} />
              </Picker>
            </Col>
          </Row>
        </View>
        <View style={styles.toggleBar}>
          <TouchableOpacity
            style={[
              styles.toggleChip,
              showColors && styles.toggleChipActive,
            ]}
            onPress={() => setShowColors(prev => !prev)}
            activeOpacity={0.7}
          >
            <FontAwesome
              name="paint-brush"
              size={12}
              color={showColors ? '#1d4ed8' : '#6b7280'}
            />
            <Text
              style={[
                styles.toggleChipText,
                showColors && styles.toggleChipTextActive,
              ]}
            >
              <T>Colors:</T> {showColors ? 'ON' : 'OFF'}
            </Text>
          </TouchableOpacity>

          <TouchableOpacity
            style={[
              styles.toggleChip,
              showBadges && styles.toggleChipActive,
            ]}
            onPress={() => setShowBadges(prev => !prev)}
            activeOpacity={0.7}
          >
            <FontAwesome
              name="tags"
              size={12}
              color={showBadges ? '#1d4ed8' : '#6b7280'}
            />
            <Text
              style={[
                styles.toggleChipText,
                showBadges && styles.toggleChipTextActive,
              ]}
            >
              <T>Badges:</T> {showBadges ? 'ON' : 'OFF'}
            </Text>
          </TouchableOpacity>

          <TouchableOpacity
            style={[
              styles.toggleChip,
              styles.toggleChipActive,
            ]}
            onPress={() => navigation?.navigate?.('PublicPlacesScreen')}
            activeOpacity={0.7}
          >
            <FontAwesome
              name="building"
              size={12}
              color="#1d4ed8"
            />
            <Text
              style={[
                styles.toggleChipText,
                styles.toggleChipTextActive,
              ]}
            >
              <T>Public Places</T>
            </Text>
          </TouchableOpacity>

          <TouchableOpacity
            style={[
              styles.toggleChip,
              styles.toggleChipActive,
            ]}
            onPress={() => navigation?.navigate?.('HKStatusScreen')}
            activeOpacity={0.7}
          >
            <FontAwesome
              name="check-square-o"
              size={12}
              color="#1d4ed8"
            />
            <Text
              style={[
                styles.toggleChipText,
                styles.toggleChipTextActive,
              ]}
            >
              <T>HK Status</T>
            </Text>
          </TouchableOpacity>
        </View>
        <View style={styles.cardContainer}>
          {rooms.map((room, index) => {
            const roomColor = getRoomColor(room, gdata);
            const contrastColor = getContrastColor(roomColor);
            const cardBg = showColors ? roomColor : '#ffffff';
            const cardTitleColor = showColors ? contrastColor : '#111827';
            const cardSubtitleColor = showColors ? contrastColor : '#4b5563';
            const iconColor = showColors ? contrastColor : roomColor;

            return (
              <Card
                key={index}
                style={[
                  styles.card,
                  {
                    backgroundColor: cardBg,
                    borderLeftWidth: showColors ? 0 : 5,
                    borderLeftColor: roomColor,
                  },
                ]}
              >
                <Card.Content>
                  {!showColors && (
                    <View
                      style={[
                        styles.statusIndicatorTag,
                        { backgroundColor: roomColor + '20' },
                      ]}
                    >
                      <Text
                        style={[
                          styles.statusIndicatorText,
                          { color: roomColor },
                        ]}
                      >
                        {getRoomStatusLabel(room)}
                      </Text>
                    </View>
                  )}
                  {showBadges && renderRoomBadges(room)}
                  <Text
                    style={[
                      styles.cardTitle,
                      {
                        color: cardTitleColor,
                      },
                    ]}
                  >
                    <FontAwesome name="bed" size={18} color={iconColor} /> {room.rm_name} (
                    {(room.rt_sname?.replace(/[^a-zA-Z]/g, '').substring(0, 3) ||
                      '') + (room.pl_code ? ' - ' + room.pl_code : '')}
                    )
                  </Text>
                  {room.ab_name && (
                    <Text
                      style={[
                        styles.subtitle,
                        {
                          color: cardSubtitleColor,
                        },
                      ]}
                    >
                      <FontAwesome name="user" size={14} color={iconColor} />{' '}
                      {room.ab_name.substring(0, 12)}
                    </Text>
                  )}
                  {room.ci_arrvial && (
                    <Text
                      style={[
                        styles.subtitle,
                        {
                          color: cardSubtitleColor,
                        },
                      ]}
                    >
                      <FontAwesome name="sign-in" size={14} color={iconColor} />{' '}
                      {moment(room.ci_arrvial).format('DD-MM-YY HH:mm')}
                    </Text>
                  )}
                  {room.ci_arrvial && (
                    <Text
                      style={[
                        styles.subtitle,
                        {
                          color: cardSubtitleColor,
                        },
                      ]}
                    >
                      <FontAwesome name="sign-out" size={14} color={iconColor} />{' '}
                      {moment(room.ci_depature).format('DD-MM-YY HH:mm')}
                    </Text>
                  )}
                  {room.rm_status !== 'V' && room.rm_status !== 'O' && (
                    <View
                      style={{
                        flexDirection: 'row',
                        alignItems: 'flex-end',
                      }}
                    >
                      <TouchableOpacity
                        onPress={() =>
                          navigation.navigate('HouseKeeping', {
                            room: room.rm_id ?? 0,
                          })
                        }
                        style={styles.iconButton}
                      >
                        <FontAwesome name="home" size={28} color={iconColor} />
                      </TouchableOpacity>
                      <TouchableOpacity
                        onPress={() => setAuthModalRoom(room)}
                        style={styles.iconButton}
                      >
                        <FontAwesome name="gavel" size={26} color={iconColor} />
                      </TouchableOpacity>
                    </View>
                  )}
                  {room.rm_status === 'V' && (
                    <View
                      style={{
                        flexDirection: 'row',
                        alignItems: 'flex-end',
                      }}
                    >
                      <TouchableOpacity
                        onPress={() =>
                          navigation.navigate('Checkin', {
                            room: room.rm_id ?? 0,
                          })
                        }
                        style={styles.iconButton}
                      >
                        <FontAwesome name="id-card" size={28} color={iconColor} />
                      </TouchableOpacity>
                      <TouchableOpacity
                        onPress={() =>
                          navigation.navigate('HouseKeeping', {
                            room: room.rm_id ?? 0,
                          })
                        }
                        style={styles.iconButton}
                      >
                        <FontAwesome name="home" size={28} color={iconColor} />
                      </TouchableOpacity>
                      <TouchableOpacity
                        onPress={() => setAuthModalRoom(room)}
                        style={styles.iconButton}
                      >
                        <FontAwesome name="gavel" size={26} color={iconColor} />
                      </TouchableOpacity>
                    </View>
                  )}
                  {room.ci_arrvial && (
                    <View
                      style={{
                        flexDirection: 'row',
                        flexWrap: 'wrap',
                        alignItems: 'center',
                        rowGap: 10,
                        marginTop: 6,
                      }}
                    >
                      <TouchableOpacity
                        onPress={() =>
                          navigation.navigate('Checkout', {
                            room: room.rm_id ?? 0,
                            checkinId: room.ci_id,
                          })
                        }
                        style={styles.iconButton}
                      >
                        <FontAwesome
                          name="shopping-cart"
                          size={26}
                          color={iconColor}
                        />
                      </TouchableOpacity>
                      <TouchableOpacity
                        onPress={() =>
                          navigation.navigate('Posting', {
                            room: room.rm_id ?? 0,
                          })
                        }
                        style={styles.iconButton}
                      >
                        <FontAwesome name="file" size={26} color={iconColor} />
                      </TouchableOpacity>
                      <TouchableOpacity
                        onPress={() =>
                          navigation.navigate('RoomShift', {
                            room: room.rm_id ?? 0,
                          })
                        }
                        style={styles.iconButton}
                      >
                        <FontAwesome name="refresh" size={26} color={iconColor} />
                      </TouchableOpacity>
                      <TouchableOpacity
                        onPress={() =>
                          navigation.navigate('Advance', {
                            room: room.rm_id ?? 0,
                          })
                        }
                        style={styles.iconButton}
                      >
                        <FontAwesome name="money" size={26} color={iconColor} />
                      </TouchableOpacity>
                      <TouchableOpacity
                        onPress={() => setExtendModalRoom(room)}
                        style={styles.iconButton}
                      >
                        <FontAwesome name="calendar-plus-o" size={24} color={iconColor} />
                      </TouchableOpacity>
                      <TouchableOpacity
                        onPress={() =>
                          navigation.navigate('LinkRooms', {
                            room: room.rm_id ?? 0,
                            checkinId: room.ci_id,
                          })
                        }
                        style={styles.iconButton}
                      >
                        <FontAwesome name="link" size={24} color={iconColor} />
                      </TouchableOpacity>
                      <TouchableOpacity
                        onPress={() => setAuthModalRoom(room)}
                        style={styles.iconButton}
                      >
                        <FontAwesome name="gavel" size={24} color={iconColor} />
                      </TouchableOpacity>
                    </View>
                  )}
                </Card.Content>
              </Card>
            );
          })}
        </View>
      </ScrollView>

      {/* Extend Stay Modal */}
      <ExtendStayModal
        visible={Boolean(extendModalRoom)}
        room={extendModalRoom}
        onClose={() => setExtendModalRoom(null)}
        onSuccess={() => refetchRooms()}
      />

      {/* Request Authorization Modal */}
      <RequestAuthorizationModal
        visible={Boolean(authModalRoom)}
        room={authModalRoom}
        siblingRooms={
          authModalRoom?.ci_id
            ? rooms.filter(
                r => r.ci_id === authModalRoom.ci_id && r.rm_status === 'O',
              )
            : []
        }
        onClose={() => setAuthModalRoom(null)}
        onSuccess={() => refetchRooms()}
      />
    </View>
  );
};

export default StatusScreen;
